import React from 'react';
import {Button, Card, Label} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from "../../shared/component/form/AvField";
import {toast} from "react-toastify";
import {STATUS} from "../../shared/utils/Constants";
import {InputSwitch} from "primereact/inputswitch";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import NumberFormat from "react-number-format";
import RestTableService from "../../shared/service/RestTableService";
import PdfDocument from "../merchant/PdfDocument";
import MerchantBranchService from "../../shared/service/MerchantBranchService";
import Loading from "../../shared/component/others/Loading";
import LocationService from "../../shared/service/LocationService";
import {ProgressSpinner} from "primereact/progressspinner";
import '../../shared/styles/SettingsPage.css';
import './FloorPlanningSave.css';

const defaultRestTable = {
    id: '', status: 'ACTIVE', tableNo: null, tableCapacity: null, locationBssId: null, active: false
};

const defaultRestTableParam = {
    size: null, rowSize: null, locationBssId: null
};
const BARCODE_BATCH_SIZE = 50;
export default class FloorPlanningSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            restTable: defaultRestTable,
            restTableParam: defaultRestTableParam,
            restTableTemp: defaultRestTable,
            loading: false,
            barcodeSource: '',
            restTableDetailsSaveButtonRender: true, defaultStatus: 'ACTIVE', restTableList: [], locationList: [],
            floorPlanListLoading: true
        }
        this.restTableService = new RestTableService();
        this.merchantBranchService = new MerchantBranchService();
        this.locationService = new LocationService();
    }


    componentDidMount() {
        let obj1 = Object.assign({}, defaultRestTable);
        this.setState({
            restTable: obj1, restTableDetailsSaveButtonRender: false,
            restTableTemp: Object.assign({}, obj1)
        });

        this.refresh();

    }

    refresh() {
        this.setState({floorPlanListLoading: true});
        Promise.all([
            this.restTableService.findAll(),
            this.locationService.findAll()
        ]).then(([restTableList, locationList]) => {
            this.setState({
                restTableList: restTableList || [],
                locationList: locationList || [],
                floorPlanListLoading: false
            });
        }).catch(() => {
            this.setState({floorPlanListLoading: false});
        });
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        <div className="settings-page__header">
                            <h1 className="settings-page__title">Floor Planning</h1>
                        </div>
                        {this.restTableDetails()}
                        {this.barcodeReport()}
                    </div>
                </AvForm>
                {this.state.loading && <Loading/>}
            </div>
        );
    }

    renderResizeSection = () => {
        if (!GeneralUtils.checkPrivilege("post_dispatchio/resttable")) {
            return null;
        }

        return (
            <div className="floor-planning__resize-section">
                <ModalConfirm header='Warning' ok='Ok' onOkClick={this.resize}
                              onCancelClick={() => this.setState({displayConfirmDialog: false})}
                              show={this.state.displayConfirmDialog}
                              message={this.state.noticeResponse}/>
                <h2 className="settings-page__section-title">Resize Table</h2>
                <div className="settings-page__filter settings-page__filter--form">
                    <div className="settings-page__filter-row settings-page__filter-row--cols-5 settings-page__form-fields">
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="resize-location">
                                    <Translate contentKey="contactManagement.mobilePhone">Location</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <AvField
                                    id="resize-location"
                                    type="select"
                                    disabled={false}
                                    className="form-control"
                                    name="locationBssId"
                                    value={this.state.restTableParam.locationBssId}
                                    onChange={this.__handleChangeParam}>
                                    <option value='' key=''/>
                                    {this.state.locationList.map(element => (
                                        <option value={element.bssId} key={element.bssId}>
                                            {element.name}
                                        </option>))}
                                </AvField>
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="resize-row-size">
                                    <Translate contentKey="restTable.tradingName">Row Size</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <NumberFormat
                                    type="number"
                                    className="form-control"
                                    name="rowSize"
                                    disabled={false}
                                    value={this.state.restTableParam.rowSize}
                                    onChange={this.__handleChangeParam}/>
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="resize-size">
                                    <Translate contentKey="restTable.tradingName">Size</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <NumberFormat
                                    type="number"
                                    className="form-control"
                                    name="size"
                                    disabled={false}
                                    value={this.state.restTableParam.size}
                                    onChange={this.__handleChangeParam}/>
                            </AvGroup>
                        </div>
                    </div>
                    <div className="settings-page__actions settings-page__actions--inline">
                        <Button color="outline-primary" className="settings-page__btn--action" onClick={() => {
                            this.showConfirmDialog();
                        }}>
                            <Translate contentKey="entity.action.delete">Resize</Translate>
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    renderQrCodeSection = () => {
        return (
            <div className="floor-planning__qrcode-block">
                <h2 className="settings-page__section-title">QR Code</h2>
                <div className="settings-page__filter settings-page__filter--form">
                    <div className="settings-page__filter-row settings-page__form-fields">
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="barcodeLocationBssId">
                                    <Translate contentKey="contactManagement.mobilePhone">Location</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <AvField
                                    id="barcodeLocationBssId"
                                    type="select"
                                    disabled={false}
                                    className="form-control"
                                    name="locationBssId"
                                    value={this.state.restTableParam.locationBssId}
                                    onChange={this.__handleChangeParam}>
                                    <option value='' key=''/>
                                    {this.state.locationList.map(element => (
                                        <option value={element.bssId} key={element.bssId}>
                                            {element.name}
                                        </option>))}
                                </AvField>
                            </AvGroup>
                        </div>
                    </div>
                    <div className="settings-page__actions settings-page__actions--inline">
                        <Button color="outline-primary" className="settings-page__btn--action" onClick={() => {
                            this.downloadBarcode();
                        }}>
                            <Translate contentKey="entity.action.add">Download</Translate>
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    generateUrl() {
        var url = GeneralUtils.getUiUrl().replaceAll("merchant.", "");
        url = url.slice(0, url.lastIndexOf("/") + 1);
        if (url.indexOf("/#/") < 0) {
            url = url.slice(0, url.lastIndexOf("/"))
        }
        url = url.replace("/#//", "/");
        url = url + "/" + localStorage.getItem("clientId") + "?";
        return url;

    }

    getLocationName = (locationBssId) => {
        const location = this.state.locationList.find(item => item.bssId === locationBssId);
        if (!location || GeneralUtils.isNullOrEmpty(location.name)) {
            return "location";
        }
        return location.name.trim().replace(/\s+/g, "_");
    }

    buildBarcodeBatchData = (list, url, locationName, startIndex) => {
        const tableBssIds = list.map(t => t.bssId).filter(id => !GeneralUtils.isNullOrEmpty(id));
        const tableNames = list.map((t, i) => (!GeneralUtils.isNullOrEmpty(t.name) ? t.name : ("#" + (startIndex + i + 1))));
        const tableNos = list.map(t => (!GeneralUtils.isNullOrEmpty(t.tableNo) ? String(t.tableNo) : null));
        const endIndex = startIndex + list.length;
        return {
            url: url,
            tableBssIds: tableBssIds,
            tableNames: tableNames,
            tableNos: tableNos,
            fileName: locationName + "_" + (startIndex + 1) + "-" + endIndex + ".pdf",
            rangeText: (startIndex + 1) + "-" + endIndex
        };
    }

    processBarcodeBatches = async (action) => {
        if (GeneralUtils.isNullOrEmpty(this.state.restTableParam.locationBssId)) {
            toast.warn("Select Location");
            return;
        }
        if (this.state.restTableList.length === 0) {
            toast.warn("Empty Floor Plan");
            return;
        }
        const selectedList = this.state.restTableList
            .filter(item => item.locationBssId === this.state.restTableParam.locationBssId)
            .filter(item => item.status === 'ACTIVE');
        if (selectedList.length === 0) {
            toast.warn("No table for selected location");
            return;
        }
        const validTables = selectedList
            .filter(item => !GeneralUtils.isNullOrEmpty(item.bssId))
            .sort((left, right) => {
                const locationCompare = (left.locationBssId || '').localeCompare(right.locationBssId || '');
                if (locationCompare !== 0) {
                    return locationCompare;
                }

                const leftTableNo = GeneralUtils.isNullOrEmpty(left.tableNo) ? Number.MAX_SAFE_INTEGER : Number(left.tableNo);
                const rightTableNo = GeneralUtils.isNullOrEmpty(right.tableNo) ? Number.MAX_SAFE_INTEGER : Number(right.tableNo);
                return leftTableNo - rightTableNo;
            });
        if (validTables.length === 0) {
            toast.warn("No tableBssId on floor plan tables");
            return;
        }

        const url = this.generateUrl();
        const locationName = this.getLocationName(this.state.restTableParam.locationBssId);
        this.setState({loading: true});
        try {
            for (let i = 0; i < validTables.length; i += BARCODE_BATCH_SIZE) {
                const batch = validTables.slice(i, i + BARCODE_BATCH_SIZE);
                const payload = this.buildBarcodeBatchData(batch, url, locationName, i);
                const response = await this.merchantBranchService.generateBarcode(payload);
                if (!GeneralUtils.isNullOrEmpty(response) && !GeneralUtils.isNullOrEmpty(response.file)) {
                    action(response);
                    toast.success("Barcode batch " + payload.rangeText + " completed");
                } else {
                    toast.warn("Barcode batch " + payload.rangeText + " returned empty file");
                }
            }
        } finally {
            this.setState({loading: false});
        }
    }

    printBarcode = () => {
        this.processBarcodeBatches((response) => {
            GeneralUtils.printFile(response);
        });
    }
    previewBarcode = () => {
        this.processBarcodeBatches((response) => {
            this.setState({
                barcodeSource: GeneralUtils.getBlob(response)
            });
        });
    }
    downloadBarcode = () => {
        this.processBarcodeBatches((response) => {
            GeneralUtils.downloadFile(response);
        });
    }

    barcodeReport() {
        if (!GeneralUtils.isNullOrEmpty(this.state.barcodeSource)) {
            return (
                <div className="settings-page__panel settings-page__section">
                    <h2 className="settings-page__section-title">Barcode Preview</h2>
                    <div className="all-page-container">
                        <PdfDocument pdf={this.state.barcodeSource}/>
                    </div>
                </div>
            );
        }
        return null;
    }

    setCheckedStatus = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.restTable.id)) {
            this.restTableService.updateStatus(this.state.restTable.id, this.state.defaultStatus)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            restTable: response,
                            restTableDetailsSaveButtonRender: false,
                            restTableTemp: Object.assign({}, response)
                        });
                        this.refresh();
                    }
                });
        } else {
            let restTable = this.state.restTable;
            restTable["status"] = this.state.restTable.status == "ACTIVE" ? "PASSIVE" : "ACTIVE";
            this.setState({restTable: restTable, restTableTemp: Object.assign({}, restTable)});
        }

        return undefined;
    }

    showChangeStatusConfirmDialog = (value) => {
        let defaultStatus = 'PASSIVE';
        if (value) {
            defaultStatus = 'ACTIVE'
        }
        this.setState({
            displayShowStatusConfirmDialog: true,
            defaultStatus: defaultStatus,
            noticeResponse: "You are about to change the status. Are you sure?"
        });
    }
    setChecked = (name, value) => {
        let restTable = this.state.restTable;
        restTable[name] = value;
        this.setState({restTable: restTable});
    }

    renderFloorPlanDetailsPanel = () => {
        const hasSelection = !GeneralUtils.isNullOrEmpty(this.state.restTable.id);

        return (
            <div className={`floor-planning__details${hasSelection ? '' : ' floor-planning__details--empty'}`}>
                <h2 className="settings-page__section-title">Floor Plan Details</h2>

                {hasSelection && (
                    <ModalConfirm header='Warning' ok='OK' onOkClick={this.setCheckedStatus}
                                  onCancelClick={() => this.setState({displayShowStatusConfirmDialog: false})}
                                  show={this.state.displayShowStatusConfirmDialog}
                                  message={this.state.noticeResponse}/>
                )}

                {!hasSelection && (
                    <p className="floor-planning__details-empty">
                        Select a table from the list to view and edit details.
                    </p>
                )}

                {hasSelection && (
                <div className="settings-page__filter settings-page__filter--form floor-planning__details-fields">
                    <div className="settings-page__filter-row settings-page__form-fields">
                        <div className="settings-page__filter-field settings-page__branch-details-status-col">
                            <AvGroup>
                                <Label for="floor-plan-status">Status</Label>
                                <div className="settings-page__status-controls">
                                    <AvField
                                        id="floor-plan-status"
                                        type="select"
                                        className="form-control"
                                        name="status"
                                        disabled={true}
                                        value={this.state.restTable.status}
                                        onChange={this.__handleChange}>
                                        {STATUS.map(element => (
                                            <option value={element.value} key={element.value}>
                                                {element.name}
                                            </option>))}
                                    </AvField>
                                    <InputSwitch
                                        checked={this.state.restTable.status == "ACTIVE"}
                                        tooltip={"Change Status"}
                                        disabled={!this.state.restTableDetailsSaveButtonRender}
                                        onChange={(e) => this.showChangeStatusConfirmDialog(e.value)}/>
                                </div>
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="floor-plan-table-no">
                                    <Translate contentKey="restTable.tradingName">Table No</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <NumberFormat
                                    type="number"
                                    className="form-control"
                                    name="tableNo"
                                    disabled={!this.state.restTableDetailsSaveButtonRender}
                                    value={this.state.restTable.tableNo}
                                    onChange={this.__handleChange}/>
                            </AvGroup>
                        </div>
                        <div className="settings-page__filter-field">
                            <AvGroup>
                                <Label for="floor-plan-capacity">
                                    <Translate contentKey="restTable.tradingName">Table Capacity</Translate>
                                </Label>
                                <NumberFormat
                                    type="number"
                                    className="form-control"
                                    name="tableCapacity"
                                    disabled={!this.state.restTableDetailsSaveButtonRender}
                                    value={this.state.restTable.tableCapacity}
                                    onChange={this.__handleChange}/>
                            </AvGroup>
                        </div>
                    </div>
                </div>
                )}

                {hasSelection && (
                <div className="settings-page__actions settings-page__actions--inline">
                    {GeneralUtils.checkPrivilege("post_dispatchio/resttable") && this.state.restTableDetailsSaveButtonRender == false &&
                        <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                            this.setState({restTableDetailsSaveButtonRender: true});
                        }}>
                            <Translate contentKey="entity.action.add">Edit</Translate>
                        </Button>}
                    {GeneralUtils.checkPrivilege("post_dispatchio/resttable") && this.state.restTableDetailsSaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                            this.saveRestTable();
                        }}>
                            <Translate contentKey="entity.action.add">Save</Translate>
                        </Button>}
                    {GeneralUtils.checkPrivilege("post_dispatchio/resttable") && this.state.restTableDetailsSaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                            let obj1 = this.state.restTableTemp;
                            this.setState({
                                restTable: Object.assign({}, obj1), restTableDetailsSaveButtonRender: false
                            });
                        }}>
                            <Translate contentKey="entity.action.cancel">Cancel</Translate>
                        </Button>}
                </div>
                )}
            </div>
        );
    }

    restTableDetails() {
        return (
            <div className="settings-page__panel settings-page__section floor-planning__body">
                <div className="floor-planning__page-grid">
                    <div className="floor-planning__top">
                        {this.renderResizeSection()}
                        {this.renderQrCodeSection()}
                    </div>
                    <div className="floor-planning__bottom">
                        <div className="floor-planning__list-section">
                            <h2 className="settings-page__section-title">Floor Plans</h2>
                            {GeneralUtils.checkPrivilege("get_dispatchio/resttable") &&
                                <div className="settings-page__floor-plan-list-wrap">
                                    {this.state.floorPlanListLoading &&
                                        <div className="settings-page__floor-plan-list-loading" aria-live="polite" aria-busy="true">
                                            <ProgressSpinner style={{width: '40px', height: '40px'}} strokeWidth="4"/>
                                            <span className="settings-page__floor-plan-list-loading-label">Loading floor plans…</span>
                                        </div>
                                    }
                                    <div className={`settings-page__floor-plan-grid${this.state.floorPlanListLoading ? ' settings-page__floor-plan-grid--loading' : ''}`}>
                                        {!this.state.floorPlanListLoading && this.itemTemplate()}
                                    </div>
                                </div>}
                        </div>
                        {this.renderFloorPlanDetailsPanel()}
                    </div>
                </div>
            </div>
        );
    }

    menuItem(item) {
        //const matchedLocation = this.state.locationList.find(loc => loc.bssId === item.locationBssId);
        //const locationName = matchedLocation ? matchedLocation.name : item.locationBssId; // eşleşme yoksa yine eskiyi göster


        const isSelected = !GeneralUtils.isNullOrEmpty(this.state.restTable.id)
            && this.state.restTable.id === item.id;
        const cardClass = isSelected
            ? 'settings-page__floor-plan-card settings-page__floor-plan-card--selected'
            : 'settings-page__floor-plan-card';

        return (
            <a href="#floorPlanning" key={item.id || item.bssId}>
                <Card title={item.description} className={cardClass} onClick={() => this.onDataSelect(item)}>
                    <p className="m-1">{item.name}</p>
                </Card>
            </a>
        );
    }

    itemTemplate() {
        let form = [];
        var i = 1;


        this.state.restTableList.forEach(itemSub => {
            form.push(
                this.menuItem(itemSub)
            );
            i++;

        });
        return form;
    }

    showConfirmDialog = () => {
        this.setState({
            displayConfirmDialog: true,
            noticeResponse: "Do you want to continue?"
        });
    }

    resize = () => {
        let obj1 = this.state.restTableParam;
        if (GeneralUtils.isNullOrEmpty(obj1.size)) {
            return toast.warn("Please fill the Size field!");
        } else if (GeneralUtils.isNullOrEmpty(obj1.rowSize)) {
            return toast.warn("Please fill the Row Size field!");
        } else {
            this.setState({floorPlanListLoading: true});
            this.restTableService.resize(obj1.size, obj1.rowSize, obj1.locationBssId).then(response => this.setState({
                restTableList: response,
                floorPlanListLoading: false
            })).catch(() => this.setState({floorPlanListLoading: false}));
        }

    }

    onDataSelect = (data) => {
        this.restTableService.findById(data.id).then(response => {
            this.setState({
                restTable: response,
                restTableDetailsSaveButtonRender: false,
                restTableTemp: Object.assign({}, response)
            });

        });

    }
    saveRestTable = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.restTable.tableNo)) {
            return toast.warn("Please fill the required fields!");
        } else {
            if (!GeneralUtils.isNullOrEmpty(this.state.restTable.id)) {
                this.restTableService.update(this.state.restTable)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.setState({
                                restTableDetailsSaveButtonRender: false, restTable: response,
                                restTableTemp: Object.assign({}, response)

                            });
                            this.refresh();
                        }
                    });
            } else {
                this.restTableService.create(this.state.restTable)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.setState({
                                restTableDetailsSaveButtonRender: false, restTable: response,
                                restTableTemp: Object.assign({}, response)
                            });
                            this.refresh();
                        }
                    });
            }
        }

    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let restTable = this.state.restTable;
        restTable[e.target.name] = value;
        this.setState({restTable: restTable});
    }

    __handleChangeParam = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let restTableParam = this.state.restTableParam;
        restTableParam[e.target.name] = value;
        this.setState({restTableParam: restTableParam});
    }

}

